import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import './NavbarPanelViewer.sass';

import { buildTestid } from '../../../lib/utils';

export interface ViewerProps extends
  WithDataTestid,
  WithClassNameProp {
  name: string;
  role?: string;
}

const displayName = 'NavbarPanelViewer';
const testid = buildTestid(displayName);

function NavbarPanelViewer({
  name,
  role = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: ViewerProps): React.JSX.Element {
  return (
    <div
      {...testid(dataTestId)}
      className={cn('NavbarPanelViewer', className)}
    >
      <div
        {...testid('Name', dataTestId)}
        className={cn('NavbarPanelViewer__Name')}
      >
        <TruncatedText
          hasTruncation
          tooltipContent={name}
        >
          {name}
        </TruncatedText>
      </div>

      {!!role && (
        <div
          {...testid('Role', dataTestId)}
          className={cn('NavbarPanelViewer__Role')}
        >
          <TruncatedText
            hasTruncation
            tooltipContent={role}
          >
            {role}
          </TruncatedText>
        </div>
      )}
    </div>
  );
}

NavbarPanelViewer.displayName = displayName;

export { NavbarPanelViewer };
